// modules
import { addModal } from 'weblite-web-modal-viewer'
import { CreateBookmarkCollectionModal } from './create-bookmark-collection-modal'

const COMPONENT_ID = 'BookmarkMakeListModal'
export const showCreateBookmarkCollectionModal = (
  props: Parameters<typeof CreateBookmarkCollectionModal>[0],
) => addModal({ id: COMPONENT_ID, props })

export const showEditBookmarkCollectionModal = (
  props: Parameters<typeof CreateBookmarkCollectionModal>[0],
) => addModal({ id: COMPONENT_ID, props })

export default {
  [COMPONENT_ID]: {
    Component: CreateBookmarkCollectionModal,
  },
}
